import { GET, POST } from "@/services/request";
import * as APIs from '@/services/APIs';

/**
 * 获取代客泊车和休息室数量
 */
export const fetchBasicNum = async (member_id) => {
  const res = await GET(APIs.API_SUBSCRIBE_MAKE_BASIC_NUM, { params: { member_id } });
  return res.data.data ?? {};
};

/**
 * 提交代客预约
 */
export const fetchSubscribe = async (data) => {
  const res = await POST(APIs.API_SUBSCRIBE_ADD, { data });
  return res.data ?? {};
};